export type NewsCardVariant = 'card' | 'standard';
export type NewsCardLayout = 'compact' | 'full';

export const mockExcerpt =
  'Lorem ipsum dolor sit amet. Ex eveniet deserunt in voluptas nesciunt ut molestiae enim ad deleniti fugiat aut facere nulla non voluptas libero id ipsum quibusdam. Et iusto officiis qui velit possimus quo esse nihil est fugit nobis qui maiores molestiae. Ea consequatur iste ad dolores cumque ut amet sint et repellendus dolores et saepe praesentium et amet consequatur.';
export const mockTitle = 'Lorem ipsum dolor sit amet. Ex eveniet deserunt in voluptas nesciunt';
